import _ from 'lodash';
import { UTCDateRange } from '@skyjs/date';
import isDateRangeExpressionValueValid from '../isDateRangeExpressionValueValid.js';

export default getQueryExpression => ({
  getPathExpression: (path, value) => {
    if (!isDateRangeExpressionValueValid('UTCDateRange', value)) {
      throw new Error(`Invalid UTCDateRange value: ${value}`);
    }

    const expression = Function('UTCDateRange', `return ${value};`)(UTCDateRange);
    const criteria = _.isArray(expression)
      ? _.set(
          {},
          '$or',
          expression.map(e => ({ [path.join('.')]: e }))
        )
      : _.set({}, path.join('.'), expression);

    return getQueryExpression(criteria);
  }
});
